/**
 * Idle detection mixin for labeling tasks.
 * Alerts after idleTimeoutSeconds of inactivity; calls onIdleTimeout when fired.
 */
export default {
  data() {
    return {
      idleTimeoutSeconds: 45,
      idleTimer: null,
      idleDialog: false,
      idleWarningShown: false,
    };
  },
  methods: {
    resetIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      this.idleTimer = setTimeout(() => {
        this.onIdleTimeout();
      }, this.idleTimeoutSeconds * 1000);
    },
    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },
    registerIdleListeners() {
      const events = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
      events.forEach(evt => {
        window.addEventListener(evt, this.resetIdleTimer, { passive: true });
      });
      this.resetIdleTimer();
    },
    unregisterIdleListeners() {
      this.clearIdleTimer();
      const events = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
      events.forEach(evt => {
        window.removeEventListener(evt, this.resetIdleTimer);
      });
    },
    onIdleTimeout() {
      this.idleDialog = true;
      this.idleWarningShown = true;
      if (typeof this.handleIdleTimeout === 'function') {
        this.handleIdleTimeout();
      }
    },
  },
  beforeDestroy() {
    this.unregisterIdleListeners();
  },
};
